import useAuth from '@/hooks/useAuth'
import {useCartState} from '@/contexts/CartContext'
import Image from 'next/image'
import Link from 'next/link'

import * as fbq from '@/services/fbpixel'
import {useRouter} from 'next/router'
import alerts from '@/config/alerts.json'
import React, {Dispatch, SetStateAction} from 'react'
import Button from './Button'
import {toast} from 'react-hot-toast'
import CustomToast from './CustomToast'
import LogoImage from '../../public/images/logo.svg'
import SearchDropdown from './SearchDropdown'
import {event} from 'nextjs-google-analytics'

type Props = {
  setIsLoginOpen: (arg0: boolean) => void
  setIsRegisterOpen: (arg0: boolean) => void
  setIsForgotOpen: (arg0: boolean) => void
  setLastOpened: Dispatch<SetStateAction<'login' | 'register'>>
  lastOpened: 'login' | 'register'
  featured_categories: any
}
export default function DesktopHeader({
  setIsLoginOpen,
  setIsRegisterOpen,
  setIsForgotOpen,
  featured_categories,
  setLastOpened,
  lastOpened,
}: Props) {
  const [search, setSearch] = React.useState('')
  const [category, setCategory] = React.useState('')

  const cart = useCartState()
  const router = useRouter()
  const {isLoading, user} = useAuth('none')
  //if (isLoading || !user) return <></>
  const SubmitSearch = () => {
    const params = new URLSearchParams({
      query: search,
      categories: category,
    })

    event('search', {
      search_term: search,
    })
    fbq.event('Search', {
      search_string: search,
    })
    router.push('/products?' + params.toString())
  }
  return (
    <div className="header-inner hidden lg:block">
      <div className="header-top-section flex justify-between items-center">
        <div className="header-left flex basis-2/3 items-center">
          <div className="logo mr-6">
            <Link href="/">
              <Image src={LogoImage} alt="logo-img" className="w-36" />
            </Link>
          </div>
          <form
            className="search-bar relative w-full mr-12  flex items-center"
            onSubmit={e => {
              e.preventDefault()
              SubmitSearch()
            }}>
            <div className="search-input w-full">
              <input
                type="text"
                className="w-full border rounded-md border-gray-300 py-[0.8rem]"
                placeholder="البحث عن منتجات....."
                onChange={e => {
                  setSearch(e.target.value)
                }}
              />
            </div>
            <div className="search-select px-4 absolute left-20">
              <SearchDropdown category={category} setCategory={setCategory} />
            </div>
            <Button
              type="submit"
              bg="primary"
              classes={[
                'left-0 text-white block absolute py-2 h-full px-8 rounded-l-md',
              ]}>
              {'بحث'}
            </Button>
          </form>
        </div>
        <div className="header-right flex items-center">
          {isLoading || !user ? (
            ''
          ) : (
            <a
              href="#"
              onClick={e => {
                e.preventDefault()
                if (!user) {
                  toast.custom((t) => <CustomToast t={t} message={alerts.login_wishlist}  type='error'/>, {
                    duration: 2500,
                  });
                  setIsLoginOpen(true)
                  return
                }
                router.push('/account/wishlist')
              }}
              className="wishlist flex">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_919_2605)">
                  <path
                    d="M20.1371 24C19.7672 23.999 19.4011 23.9247 19.0601 23.7813C18.719 23.638 18.4097 23.4285 18.1501 23.165L12.0001 17.051L5.85012 23.169C5.45515 23.5697 4.94861 23.8422 4.39654 23.9508C3.84447 24.0594 3.27247 23.9992 2.75512 23.778C2.23264 23.5678 1.78567 23.205 1.47258 22.7369C1.15949 22.2688 0.994841 21.7171 1.00012 21.154V5C1.00012 3.67392 1.52691 2.40215 2.46459 1.46447C3.40227 0.526784 4.67404 0 6.00012 0L18.0001 0C18.6567 0 19.3069 0.129329 19.9135 0.380602C20.5202 0.631876 21.0714 1.00017 21.5357 1.46447C22 1.92876 22.3683 2.47996 22.6195 3.08658C22.8708 3.69321 23.0001 4.34339 23.0001 5V21.154C23.0057 21.7167 22.8417 22.268 22.5293 22.7361C22.217 23.2041 21.7709 23.5672 21.2491 23.778C20.8969 23.9253 20.5189 24.0008 20.1371 24ZM6.00012 2C5.20447 2 4.44141 2.31607 3.8788 2.87868C3.31619 3.44129 3.00012 4.20435 3.00012 5V21.154C2.99976 21.3206 3.04879 21.4836 3.14102 21.6224C3.23325 21.7612 3.36455 21.8695 3.51831 21.9337C3.67208 21.9979 3.84143 22.0151 4.00496 21.9831C4.1685 21.9512 4.31888 21.8714 4.43712 21.754L11.3001 14.933C11.4875 14.7468 11.7409 14.6422 12.0051 14.6422C12.2693 14.6422 12.5228 14.7468 12.7101 14.933L19.5651 21.752C19.6834 21.8694 19.8338 21.9492 19.9973 21.9811C20.1608 22.0131 20.3302 21.9959 20.4839 21.9317C20.6377 21.8675 20.769 21.7592 20.8612 21.6204C20.9535 21.4816 21.0025 21.3186 21.0021 21.152V5C21.0021 4.20435 20.6861 3.44129 20.1234 2.87868C19.5608 2.31607 18.7978 2 18.0021 2H6.00012Z"
                    fill="#00214D"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_919_2605">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <p className="mr-4 text-primary font-semibold">المحفوظات</p>
            </a>
          )}

          {/*
           *<div className="flex items-center gap-[24px]">
           *  <a
           *    onClick={e => {
           *      e.preventDefault()
           *      if (user) {
           *        router.push('/account')
           *      } else {
           *        if (lastOpened == 'register') {
           *          setLastOpened('register')
           *          setIsRegisterOpen(true)
           *        } else {
           *          setLastOpened('login')
           *          setIsLoginOpen(true)
           *        }
           *      }
           *    }}
           *    className="cursor-pointer user flex border border-primary text-center py-3 px-9 rounded text-sm">
           *    <p className="text-primary font-semibold">
           *      {!user ? 'تسجيل الدخول' : 'مرحباً, ' + user?.first_name}
           *    </p>
           *  </a>
           *  {!user && (
           *    <a
           *      onClick={e => {
           *        setIsRegisterOpen(true)
           *      }}
           *      className="cursor-pointer user flex bg-primary text-center py-3 px-9 rounded text-sm">
           *      <p className="text-white font-semibold">أنشاء حساب</p>
           *    </a>
           *  )}
           *</div>
           */}

          <a
            onClick={e => {
              e.preventDefault()
              if (user) {
                router.push('/account')
              } else {
                if (lastOpened == 'register') {
                  setLastOpened('register')
                  setIsRegisterOpen(true)
                } else {
                  setLastOpened('login')
                  setIsLoginOpen(true)
                }
              }
            }}
            className="cursor-pointer user flex mr-12">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_919_2599)">
                <path
                  d="M12 11.9999C13.1867 11.9999 14.3467 11.648 15.3334 10.9887C16.3201 10.3294 17.0892 9.39234 17.5433 8.29598C17.9974 7.19963 18.1162 5.99323 17.8847 4.82934C17.6532 3.66545 17.0818 2.59635 16.2426 1.75724C15.4035 0.918125 14.3344 0.34668 13.1705 0.115169C12.0067 -0.116342 10.8003 0.00247765 9.7039 0.456603C8.60754 0.910729 7.67047 1.67976 7.01118 2.66646C6.35189 3.65315 6 4.81319 6 5.99988C6.00159 7.59069 6.63424 9.11589 7.75911 10.2408C8.88399 11.3656 10.4092 11.9983 12 11.9999ZM12 1.99988C12.7911 1.99988 13.5645 2.23448 14.2223 2.674C14.8801 3.11353 15.3928 3.73824 15.6955 4.46915C15.9983 5.20005 16.0775 6.00432 15.9231 6.78024C15.7688 7.55617 15.3878 8.2689 14.8284 8.82831C14.269 9.38772 13.5563 9.76868 12.7804 9.92302C12.0044 10.0774 11.2002 9.99815 10.4693 9.6954C9.73836 9.39265 9.11365 8.87996 8.67412 8.22216C8.2346 7.56436 8 6.79101 8 5.99988C8 4.93901 8.42143 3.9216 9.17157 3.17145C9.92172 2.42131 10.9391 1.99988 12 1.99988Z"
                  fill="#00214D"
                />
                <path
                  d="M12 14C9.61386 14.0026 7.32622 14.9517 5.63896 16.639C3.95171 18.3262 3.00265 20.6139 3 23C3 23.2652 3.10536 23.5196 3.29289 23.7071C3.48043 23.8946 3.73478 24 4 24C4.26522 24 4.51957 23.8946 4.70711 23.7071C4.89464 23.5196 5 23.2652 5 23C5 21.1435 5.7375 19.363 7.05025 18.0503C8.36301 16.7375 10.1435 16 12 16C13.8565 16 15.637 16.7375 16.9497 18.0503C18.2625 19.363 19 21.1435 19 23C19 23.2652 19.1054 23.5196 19.2929 23.7071C19.4804 23.8946 19.7348 24 20 24C20.2652 24 20.5196 23.8946 20.7071 23.7071C20.8946 23.5196 21 23.2652 21 23C20.9974 20.6139 20.0483 18.3262 18.361 16.639C16.6738 14.9517 14.3861 14.0026 12 14Z"
                  fill="#00214D"
                />
              </g>
              <defs>
                <clipPath id="clip0_919_2599">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p className="mr-4 text-primary font-semibold">
              {!user ? 'حسابي' : 'مرحباً, ' + user?.first_name}
            </p>
          </a>
        </div>
      </div>
      <div className="header-bottom flex items-center justify-between pt-8">
        <div className="header-right flex items-center">
          <Link
            href="/products"
            className="flex px-5 text-lg py-3 rounded-md ml-6 items-center text-white bg-primary">
            <span className="ml-2">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_919_2648)">
                  <path
                    d="M7 0H4C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4L0 7C0 8.06087 0.421427 9.07828 1.17157 9.82843C1.92172 10.5786 2.93913 11 4 11H7C8.06087 11 9.07828 10.5786 9.82843 9.82843C10.5786 9.07828 11 8.06087 11 7V4C11 2.93913 10.5786 1.92172 9.82843 1.17157C9.07828 0.421427 8.06087 0 7 0V0ZM9 7C9 7.53043 8.78929 8.03914 8.41421 8.41421C8.03914 8.78929 7.53043 9 7 9H4C3.46957 9 2.96086 8.78929 2.58579 8.41421C2.21071 8.03914 2 7.53043 2 7V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H7C7.53043 2 8.03914 2.21071 8.41421 2.58579C8.78929 2.96086 9 3.46957 9 4V7Z"
                    fill="#FFFFFE"
                  />
                  <path
                    d="M20 0H17C15.9391 0 14.9217 0.421427 14.1716 1.17157C13.4214 1.92172 13 2.93913 13 4V7C13 8.06087 13.4214 9.07828 14.1716 9.82843C14.9217 10.5786 15.9391 11 17 11H20C21.0609 11 22.0783 10.5786 22.8284 9.82843C23.5786 9.07828 24 8.06087 24 7V4C24 2.93913 23.5786 1.92172 22.8284 1.17157C22.0783 0.421427 21.0609 0 20 0V0ZM22 7C22 7.53043 21.7893 8.03914 21.4142 8.41421C21.0391 8.78929 20.5304 9 20 9H17C16.4696 9 15.9609 8.78929 15.5858 8.41421C15.2107 8.03914 15 7.53043 15 7V4C15 3.46957 15.2107 2.96086 15.5858 2.58579C15.9609 2.21071 16.4696 2 17 2H20C20.5304 2 21.0391 2.21071 21.4142 2.58579C21.7893 2.96086 22 3.46957 22 4V7Z"
                    fill="#FFFFFE"
                  />
                  <path
                    d="M7 13H4C2.93913 13 1.92172 13.4214 1.17157 14.1716C0.421427 14.9217 0 15.9391 0 17L0 20C0 21.0609 0.421427 22.0783 1.17157 22.8284C1.92172 23.5786 2.93913 24 4 24H7C8.06087 24 9.07828 23.5786 9.82843 22.8284C10.5786 22.0783 11 21.0609 11 20V17C11 15.9391 10.5786 14.9217 9.82843 14.1716C9.07828 13.4214 8.06087 13 7 13ZM9 20C9 20.5304 8.78929 21.0391 8.41421 21.4142C8.03914 21.7893 7.53043 22 7 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V17C2 16.4696 2.21071 15.9609 2.58579 15.5858C2.96086 15.2107 3.46957 15 4 15H7C7.53043 15 8.03914 15.2107 8.41421 15.5858C8.78929 15.9609 9 16.4696 9 17V20Z"
                    fill="#FFFFFE"
                  />
                  <path
                    d="M20 13H17C15.9391 13 14.9217 13.4214 14.1716 14.1716C13.4214 14.9217 13 15.9391 13 17V20C13 21.0609 13.4214 22.0783 14.1716 22.8284C14.9217 23.5786 15.9391 24 17 24H20C21.0609 24 22.0783 23.5786 22.8284 22.8284C23.5786 22.0783 24 21.0609 24 20V17C24 15.9391 23.5786 14.9217 22.8284 14.1716C22.0783 13.4214 21.0609 13 20 13ZM22 20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H17C16.4696 22 15.9609 21.7893 15.5858 21.4142C15.2107 21.0391 15 20.5304 15 20V17C15 16.4696 15.2107 15.9609 15.5858 15.5858C15.9609 15.2107 16.4696 15 17 15H20C20.5304 15 21.0391 15.2107 21.4142 15.5858C21.7893 15.9609 22 16.4696 22 17V20Z"
                    fill="#FFFFFE"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_919_2648">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            كل التصنيفات
            <span className="mr-2">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_919_2644)">
                  <path
                    d="M11.9473 1.00003C11.947 1.26516 11.8415 1.51934 11.6539 1.7067L6.53927 6.82136C6.38446 6.97613 6.26165 7.15988 6.17786 7.36212C6.09408 7.56436 6.05096 7.78112 6.05096 8.00003C6.05096 8.21894 6.09408 8.4357 6.17786 8.63794C6.26165 8.84017 6.38445 9.02392 6.53927 9.1787L11.6473 14.29C11.8294 14.4786 11.9302 14.7312 11.9279 14.9934C11.9257 15.2556 11.8205 15.5064 11.6351 15.6918C11.4497 15.8773 11.1989 15.9824 10.9367 15.9847C10.6745 15.987 10.4219 15.8862 10.2333 15.704L5.12527 10.5967C4.43844 9.90852 4.0527 8.97597 4.0527 8.00369C4.0527 7.03142 4.43844 6.09887 5.12527 5.4107L10.2399 0.296029C10.3796 0.156284 10.5575 0.0610369 10.7512 0.0223082C10.945 -0.0164224 11.1458 0.00310128 11.3285 0.078413C11.5111 0.153726 11.6674 0.281452 11.7775 0.445475C11.8876 0.609497 11.9467 0.802465 11.9473 1.00003Z"
                    fill="#FFFFFE"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_919_2644">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(16 16) rotate(-180)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
          </Link>
          <ul className="category-list-desktop">
            {featured_categories?.map((category: any) => {
              return (
                <li key={category.id}>
                  <Link href={`/products?categories=${category.slug}`}>
                    {category.name}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
        <div className="header-left">
          <button
            onClick={e => {
              e.preventDefault()
              router.push('/cart')
            }}
            className="cart-info bg-success rounded-md flex items-center py-[.5rem] px-6">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              className="ml-3"
              xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_919_8799)">
                <path
                  d="M22.713 4.577C22.4317 4.23944 22.0796 3.96795 21.6815 3.78182C21.2835 3.59568 20.8494 3.49946 20.41 3.5H4.242L4.2 3.149C4.11405 2.41942 3.76338 1.74673 3.21449 1.25848C2.6656 0.770223 1.95663 0.500342 1.222 0.5L1 0.5C0.734784 0.5 0.48043 0.605357 0.292893 0.792893C0.105357 0.98043 0 1.23478 0 1.5C0 1.76522 0.105357 2.01957 0.292893 2.20711C0.48043 2.39464 0.734784 2.5 1 2.5H1.222C1.46693 2.50003 1.70334 2.58996 1.88637 2.75272C2.06941 2.91547 2.18634 3.13975 2.215 3.383L3.591 15.083C3.73385 16.2998 4.31848 17.4218 5.23391 18.236C6.14934 19.0502 7.33185 19.5 8.557 19.5H19C19.2652 19.5 19.5196 19.3946 19.7071 19.2071C19.8946 19.0196 20 18.7652 20 18.5C20 18.2348 19.8946 17.9804 19.7071 17.7929C19.5196 17.6054 19.2652 17.5 19 17.5H8.557C7.93806 17.4983 7.3348 17.3051 6.82994 16.9471C6.32507 16.589 5.94331 16.0835 5.737 15.5H17.657C18.8293 15.5001 19.9643 15.0882 20.8638 14.3364C21.7633 13.5846 22.37 12.5407 22.578 11.387L23.363 7.033C23.4414 6.60101 23.4237 6.15707 23.3114 5.73264C23.1991 5.30821 22.9948 4.91368 22.713 4.577ZM21.4 6.678L20.614 11.032C20.4891 11.725 20.1245 12.352 19.5839 12.8032C19.0433 13.2544 18.3612 13.5011 17.657 13.5H5.419L4.478 5.5H20.41C20.5569 5.49912 20.7022 5.53062 20.8355 5.59226C20.9689 5.65389 21.087 5.74415 21.1815 5.85661C21.276 5.96907 21.3446 6.10097 21.3824 6.24294C21.4201 6.3849 21.4262 6.53344 21.4 6.678Z"
                  fill="#00214D"
                />
                <path
                  d="M7 24.5C8.10457 24.5 9 23.6046 9 22.5C9 21.3954 8.10457 20.5 7 20.5C5.89543 20.5 5 21.3954 5 22.5C5 23.6046 5.89543 24.5 7 24.5Z"
                  fill="#00214D"
                />
                <path
                  d="M17 24.5C18.1046 24.5 19 23.6046 19 22.5C19 21.3954 18.1046 20.5 17 20.5C15.8954 20.5 15 21.3954 15 22.5C15 23.6046 15.8954 24.5 17 24.5Z"
                  fill="#00214D"
                />
              </g>
              <defs>
                <clipPath id="clip0_919_8799">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            <div className="cart-info-text pr-4 border-r-[1px] border-r-primary-500">
              <p>{cart.items.length} منتج </p>
              <strong>₪ {cart.total}</strong>
            </div>
          </button>
        </div>
      </div>
    </div>
  )
}
